import { render } from "./NavMobDesk.vue?vue&type=template&id=a5909e2a&scoped=true"
import script from "./NavMobDesk.vue?vue&type=script&lang=js"
export * from "./NavMobDesk.vue?vue&type=script&lang=js"

import "./NavMobDesk.vue?vue&type=style&index=0&id=a5909e2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a5909e2a"

export default script